/**
 * State-level sales tax rates (decimal, e.g. 0.0825 = 8.25%).
 * Used for dashboard sales tax liability. Location/company state from onboarding determines rate.
 * No sales tax: AK, DE, MT, NH, OR.
 */
export const STATE_SALES_TAX_RATES: Record<string, number> = {
  AL: 0.0929,
  AK: 0,
  AZ: 0.0825,
  AR: 0.0947,
  CA: 0.0725,
  CO: 0.0763,
  CT: 0.0635,
  DE: 0,
  FL: 0.06,
  GA: 0.04,
  HI: 0.0435,
  ID: 0.06,
  IL: 0.0625,
  IN: 0.07,
  IA: 0.06,
  KS: 0.065,
  KY: 0.06,
  LA: 0.09565,
  ME: 0.055,
  MD: 0.06,
  MA: 0.0625,
  MI: 0.06,
  MN: 0.065,
  MS: 0.07,
  MO: 0.04225,
  MT: 0,
  NE: 0.055,
  NV: 0.0685,
  NH: 0,
  NJ: 0.06625,
  NM: 0.05125,
  NY: 0.04, // state only; local varies
  NC: 0.03,
  ND: 0.05,
  OH: 0.0575,
  OK: 0.045,
  OR: 0,
  PA: 0.06,
  RI: 0.07,
  SC: 0.06,
  SD: 0.045,
  TN: 0.09556,
  TX: 0.0825,
  UT: 0.061,
  VT: 0.06,
  VA: 0.053,
  WA: 0.065,
  WV: 0.06,
  WI: 0.05,
  WY: 0.04,
};

/** Get sales tax rate for a state code (default 0 if unknown or no-tax state). */
export function getStateSalesTaxRate(stateCode: string | null | undefined): number {
  if (!stateCode) return 0;
  return STATE_SALES_TAX_RATES[stateCode.toUpperCase()] ?? 0;
}
